'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessage = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Translate = require('../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessage = exports.getMessage = function getMessage(key) {
  var messages = {
    // Payment methods
    BankDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.BankDeposit', defaultMessage: 'Bank' }),
    CreditcardDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.CreditcardDeposit',
      defaultMessage: 'Creditcard'
    }),
    ZimplerDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.ZimplerDeposit', defaultMessage: 'Zimpler' }),
    SiruDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.SiruDeposit', defaultMessage: 'Siru' }),
    TrustlyDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.TrustlyDeposit', defaultMessage: 'Trustly' }),
    ZimplerWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.ZimplerWithdrawal',
      defaultMessage: 'Zimpler'
    }),
    InteracWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.InteracWithdrawal',
      defaultMessage: 'Interac'
    }),
    CreditcardWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.CreditcardWithdrawal',
      defaultMessage: 'Creditcard'
    }),
    TrustlyWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.TrustlyWithdrawal',
      defaultMessage: 'Trustly'
    }),
    NetellerDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.NetellerDeposit', defaultMessage: 'Neteller' }),
    PaysafecardDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.PaysafecardDeposit',
      defaultMessage: 'Paysafecard'
    }),
    AstroPayCardWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.AstroPayCardWithdrawal',
      defaultMessage: 'AstroPayCard'
    }),
    InstadebitWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.InstadebitWithdrawal',
      defaultMessage: 'Instadebit'
    }),
    IDebitDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.IDebitDeposit', defaultMessage: 'IDebit' }),
    EcoPayzDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.EcoPayzDeposit', defaultMessage: 'EcoPayz' }),
    InstadebitDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.InstadebitDeposit',
      defaultMessage: 'Instadebit'
    }),
    AstroPayCardDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.AstroPayCardDeposit',
      defaultMessage: 'AstroPayCard'
    }),
    MuchBetterDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.MuchBetterDeposit',
      defaultMessage: 'MuchBetter'
    }),
    EcoPayzWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.EcoPayzWithdrawal',
      defaultMessage: 'EcoPayz'
    }),
    NetellerWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.NetellerWithdrawal',
      defaultMessage: 'Neteller'
    }),
    SkrillDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.SkrillDeposit', defaultMessage: 'Skrill' }),
    SkrillWithdraw: _react2.default.createElement(_Translate2.default, { id: 'label.history.SkrillWithdrawal', defaultMessage: 'Skrill' }),
    IDebitWithdraw: _react2.default.createElement(_Translate2.default, { id: 'label.history.IDebitWithdrawal', defaultMessage: 'IDebit' }),
    AstroPayBankWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.AstroPayBankWithdrawal',
      defaultMessage: 'AstroPayBank'
    }),
    MuchBetterWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.MuchBetterWithdrawal',
      defaultMessage: 'MuchBetter'
    }),
    SwishDeposit: _react2.default.createElement(_Translate2.default, { id: 'label.history.SwishDeposit', defaultMessage: 'Swish' }),
    JetonWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.JetonWithdrawal',
      defaultMessage: 'JetonWithdrawal'
    }),
    JetonDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.JetonDeposit',
      defaultMessage: 'JetonDeposit'
    }),
    BestPayDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.BestPayDeposit',
      defaultMessage: 'BestPayDeposit'
    }),
    BestPayWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.BestPayDeposit',
      defaultMessage: 'BestPayDeposit'
    }),
    CryptoCurrencyDeposit: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.CryptoCurrencyDeposit',
      defaultMessage: 'CryptoCurrencyDeposit'
    }),
    CryptoCurrencyWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.CryptoCurrencyWithdrawal',
      defaultMessage: 'CryptoCurrencyWithdrawal'
    }),
    BankLocalWithdraw: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.BankLocalWithdrawal',
      defaultMessage: 'BankLocalWithdrawal'
    }),

    // Products
    casino: _react2.default.createElement(_Translate2.default, { id: 'label.history.product-casino', defaultMessage: 'Casino' }),
    payments: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.product-payments',
      defaultMessage: 'Payments'
    }),
    sportsbook: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.product-sportsbook',
      defaultMessage: 'Sportsbook'
    }),
    fantasy: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.product-fantasy',
      defaultMessage: 'Fantasy sports'
    }),
    bingo: _react2.default.createElement(_Translate2.default, { id: 'label.history.product-bingo', defaultMessage: 'Bingo' }),

    // Status
    initiated: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.status-initiated',
      defaultMessage: 'Initiated'
    }),
    canceled: _react2.default.createElement(_Translate2.default, { id: 'label.history.status-canceled', defaultMessage: 'Canceled' }),
    completed: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.status-completed',
      defaultMessage: 'Completed'
    }),
    rollbacked: _react2.default.createElement(_Translate2.default, {
      id: 'label.history.status-rollbacked',
      defaultMessage: 'Rollbacked'
    }),
    settled: _react2.default.createElement(_Translate2.default, { id: 'label.history.status-settled', defaultMessage: 'Settled' }),
    pendling: _react2.default.createElement(_Translate2.default, { id: 'label.history.status-pendling', defaultMessage: 'Pendling' })
  };

  return messages[key] || _react2.default.createElement(
    'span',
    null,
    key
  );
};